import {
	CircularProgress,
	Dialog,
	DialogContent,
	DialogContentText,
	Grid,
	Typography,
} from '@mui/material'
import { isEqual } from 'lodash'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

export default function DisconnectedDialog() {
	const { i18n } = useTranslation()
	const [isOnline, setIsOnline] = useState(navigator.onLine)
	const [isOnlineText, setIsOnlineText] = useState({
		initial: true,
		message: i18n.t("common.YOU'RE_NOT_CONNECTED_TO_THE_INTERNET"),
	})

	useEffect(() => {
		window.addEventListener('online', () => {
			setIsOnlineText({
				initial: false,
				message: i18n.t('common.YOUR_CONNECTION_IS_NOW_STABLE!'),
			})
			setTimeout(() => {
				setIsOnline(navigator.onLine)
			}, 2500)
		})
		window.addEventListener('offline', () => {
			setIsOnlineText({
				initial: true,
				message: i18n.t("common.YOU'RE_NOT_CONNECTED_TO_THE_INTERNET"),
			})
			setIsOnline(navigator.onLine)
		})
	}, [])

	return (
		<Dialog
			open={!isOnline}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					<p>
						<b>{isOnlineText.message}</b>
					</p>
					{isOnlineText.initial ? (
						<p>
							<Grid
								container
								spacing={1}
								style={{ margin: '0 auto' }}
							>
								<Grid item>
									<CircularProgress size={25} thickness={4} />
								</Grid>
								<Grid item>
									<Typography variant="body1">
										{i18n.t('common.TRYING_TO_RECONNECT')}
										...
									</Typography>
								</Grid>
							</Grid>
						</p>
					) : null}
				</DialogContentText>
			</DialogContent>
		</Dialog>
	)
}
